// extracted by css-extract-rspack-plugin
export default {"Flash":"EditingForkBanner-module__Flash__xcvcE"};